import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const Container = styled.div``;
export const InputCont = styled.div`
  display: flex;
  align-items: center;
  > div > div {
    margin-right: 20px;
  }
  input {
    width: 60px !important;
    height: 60px !important;
    border: 1px #d0d0d0 solid;
    border-radius: 2px;
    outline: 0;
    font-family: 'Lato';
    font-size: 20px;
    line-height: 24px;
    color: #4a4a4a;
    font-weight: 700;
  }
  @media ${device.mobileS} {
    > div > div {
      margin-right: 8px;
    }
    input {
      width: 35px !important;
      height: 35px !important;
      font-size: 16px;
      line-height: 18px;
    }
  }
`;
export const LabelText = styled.p`
  font-size: 16px;
  color: #4a4a4a;
  font-weight: 700;
  margin-bottom: 15px;
  @media ${device.mobileS} {
    font-size: 14px;
    margin-bottom: 10px;
  }
`;
export const Resend = styled.a`
  font-size: 16px;
  color: #0091ff;
  font-weight: 400;
  margin-top: 32px;
  cursor: pointer;
  display: inline-flex;
  @media ${device.mobileS} {
    font-size: 12px;
    margin-top: 24px;
    font-weight: 700;
  }
`;
